import classNames from 'classnames'
import { map } from 'lodash'
import { formatPrice } from 'lib/utils'
import { getDiscountSourceBadgeClass, getDiscountSourceLabel } from '../bookingDetailHelpers'

/** "− 10.000 OMR · Ajarlee" chip naming who funded the discount. */
export const BookingDiscountSourceChip = ({ sources = [], amount = 0, t, className = '' }) => {
  if (!(amount > 0)) return null

  const label = sources.length ? map(sources, source => getDiscountSourceLabel(t, source)).join(' + ') : null
  const badgeClass = sources.length === 1 ? getDiscountSourceBadgeClass(sources[0]) : 'bg-slate-200 text-slate-700 ring-slate-300/50'
  const text = label
    ? t('booking.orderSummary.discountBySource', { amount: formatPrice(amount, true), currency: t('common.omr'), source: label })
    : t('booking.orderSummary.discountAmount', { amount: formatPrice(amount, true), currency: t('common.omr') })

  return <span className={classNames('inline-flex items-center rounded-full px-2 py-0.5 text-[11px] font-semibold leading-snug ring-1', badgeClass, className)}>{text}</span>
}

/**
 * Price cell that keeps the original amount struck through next to the charged one whenever a discount was
 * applied — including a 100% discount (charged amount 0) — and names the source that funded it.
 * `discount` comes from getBookingDiscountBreakdown / getBookingTotalSummary.
 */
const BookingDiscountedAmount = ({ discount, t, valueClassName = '', showSource = true }) => {
  const charged = Number(discount?.discounted || 0)

  if (!discount?.hasDiscount) {
    return (
      <span className={valueClassName}>
        {formatPrice(charged, true)} {t('common.omr')}
      </span>
    )
  }

  // `span` (not `div`) so the cell stays valid inside the inline value wrappers these cards use.
  return (
    <span className="inline-flex flex-col items-start sm:items-end gap-0.5">
      <span className="line-through text-gray-400 text-sm font-normal">
        {formatPrice(discount.original, true)} {t('common.omr')}
      </span>
      <span className={classNames('text-green-600', valueClassName)}>
        {formatPrice(charged, true)} {t('common.omr')}
      </span>
      {showSource && <BookingDiscountSourceChip sources={discount.sources} amount={discount.amount} t={t} className="mt-0.5" />}
    </span>
  )
}

export default BookingDiscountedAmount
